module.exports = __webpack_public_path__ + "static/media/my-account-bg.8b77eda5.jpg";